import { get, getBlob, patch, post, remove } from "../http-client/client";
import { ApiResponse } from "../http-client/Response";

export interface StandardAgreement {
  id: string;
  name: string;
  agreementType: string | null;
  description: string | null;
  fileName: string;
  contentType: string;
  sizeBytes: number;
  /** Uploader's name; null when unknown */
  uploadedBy: string | null;
  createdAt: string;
  updatedAt: string;
  /** The version comparisons run against, and whether it is prepared */
  currentVersion: {
    id: string;
    version: number;
    status: "pending" | "preparing" | "ready" | "failed";
    clauseCount: number | null;
    error: string | null;
  } | null;
}

export const STANDARD_AGREEMENT_ACCEPT =
  ".docx,.pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf";
export const MAX_STANDARD_AGREEMENT_BYTES = 25 * 1024 * 1024;

export const listStandardAgreements = (): Promise<
  ApiResponse<StandardAgreement[]>
> => get(`/standard-agreements`, null);

export const uploadStandardAgreement = (
  file: File,
  details: { name?: string; agreementType?: string; description?: string },
): Promise<ApiResponse<StandardAgreement>> => {
  const formData = new FormData();
  formData.append("file", file);
  for (const [key, value] of Object.entries(details)) {
    if (value?.trim()) formData.append(key, value.trim());
  }
  return post<StandardAgreement>(`/standard-agreements`, formData, null);
};

export const updateStandardAgreement = (
  id: string,
  details: { name?: string; agreementType?: string | null; description?: string | null },
): Promise<ApiResponse<StandardAgreement>> =>
  patch(`/standard-agreements/${id}`, details, null);

export const deleteStandardAgreement = (
  id: string,
): Promise<ApiResponse<void>> => remove(`/standard-agreements/${id}`, null);

export const downloadStandardAgreement = (
  id: string,
): Promise<ApiResponse<Blob>> => getBlob(`/standard-agreements/${id}/file`);

/** Re-queue preparation of a failed or stale standard */
export const retryStandardAgreement = (
  id: string,
): Promise<ApiResponse<StandardAgreement>> =>
  post<StandardAgreement>(`/standard-agreements/${id}/prepare`, {}, null);
